// @flow

import React from "react";
import { localize } from "redux-i18n";
import type { DefaultStandardScript } from "@modules/service/reducer/default-standard-scripts/types";
import { Button, SchemaForm, Modal, ModalBody, ModalFooter, ModalHeader, Col } from "@components";
import uiSchema from "./uiSchema";
import schema from "./schema";

type OwnProps = $Exact<{
  isOpen: boolean,
  onCancel: () => void,
  onSubmit: (form: Object) => void,
  formData: DefaultStandardScript,
}>;

type Props = $Exact<{
  ...OwnProps,
  ...PropsFromLocalize,
}>;

type State = $Exact<{
  count: number,
  formData: Object | null,
}>;

export class DefaultStandardScriptEditModal extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    // Class components needs constructor for accessing the SchemaForm's ref
    this.formRef = React.createRef();
  }

  state = {
    count: schema.properties.scriptText.maxLength,
    formData: null,
  };

  componentDidMount() {
    this.setDefaultData();
  }

  submitForm = () => {
    if (this.formRef) {
      this.formRef.current.submit();
    }
  };

  setDefaultData = () => {
    const { formData } = this.props;
    this.setState({
      ...this.state,
      formData,
      count: schema.properties.scriptText.maxLength - formData.content.scriptText.length,
    });
  };

  handleSubmit = (form: Object) => {
    if (form) {
      const updatedDraft = {
        ...this.props.formData,
        ...this.state.formData,
      };
      this.props.onSubmit(updatedDraft);
    }
  };

  handleChange = (formData: Object) => {
    const textLength = (formData.scriptText || "").length;

    this.setState({
      ...this.state,
      formData: {
        ...this.state.formData,
        content: {
          ...this.state.formData?.content,
          ...formData,
          scriptText: formData.scriptText || "",
        },
      },
      count: schema.properties.scriptText.maxLength - textLength,
    });
  };

  render() {
    return (
      <Modal className="modal-normal">
        <ModalHeader toggle={this.props.onCancel} className="d-flex justify-content-between">
          {this.props.t("EDIT_FOR_SCRIPT", {
            scriptName: this.props.formData.content.masterScript.name,
          })}
        </ModalHeader>
        <ModalBody>
          <SchemaForm
            ref={this.formRef}
            formData={this.state.formData?.content}
            schema={schema}
            onSubmit={this.handleSubmit}
            onChange={this.handleChange}
            uiSchema={uiSchema}
            externalSubmit
          />
          <div
            className="pl-2"
            dangerouslySetInnerHTML={{
              __html: this.props.t("CHARS_LEFT", {
                count: this.state.count,
              }),
            }}
          />
        </ModalBody>
        <ModalFooter className="d-flex justify-content-end">
          <Button color="secondary" onClick={this.props.onCancel}>
            {this.props.t("CANCEL")}
          </Button>
          <Button materialIcon="save" onClick={this.submitForm}>
            {this.props.t("SAVE")}
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default localize()(DefaultStandardScriptEditModal);
